import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/administration")({
  component: () => <Outlet />,
})
